<template>
  <div>
    <v-file-input
      color="primary"
      :disabled="disabled"
      prepend-icon="mdi-folder-zip"
      label="Upload .zip containing the .shp file"
      filled
      accept=".zip"
      v-model="editableFileName"
      hide-details
    >
    </v-file-input>

    <v-select
      class="mt-3"
      color="primary"
      :disabled="disabled"
      :loading="loadingField"
      :items="fieldNames"
      v-model="editableFieldName"
      filled
      hint="Select a field name"
      label="Select the geometry name in shape file">
    </v-select>

  </div>
</template>
<script>
  export default {
    name: "ShapeFileUpload",
    props: {
      fetchGeometryFieldNames: {},
      fieldName: {},
      fieldNames: {},
      fileName: {},
      loadingField: {},
      disabled: { required: false, default: false }
    },
    computed: {
      editableFieldName: {
        get () {
          return this.fieldName
        },
        set (value) {
          this.$emit("updateFieldName", value)
        }
      },
      editableFileName: {
        get () {
          return this.fileName
        },
        set (value) {
          this.$emit("updateFileName", value)
          this.$emit("fetchGeometryFieldNames")
        }
      }
    }
  }
</script>